import Layout from 'layouts/Layout/Layout'
import imgHomeCiblerBienAVendre from 'assets/default/png/home_cibler_bien_a_vendre.png'
import { Button } from 'react-bootstrap'
import Translation from '../../assets/default/translation.json'
import s from './BienAVendreNonAutorise.module.scss'

const BiensAVendreNonAutorise = (): JSX.Element => (
  <Layout>
    <div className={s.main}>
      <div className={s.textImgWrp}>
        <div>
          <h2>
            Patience... tu auras bientôt accès à l&apos;espace « Cibler biens à
            vendre ».
          </h2>
          <p>
            Cet espace est réservé aux {Translation.common.mandataire}s ayant{' '}
            <b>plus de 6 mois d&apos;ancienneté</b>.<br />
            En effet,{' '}
            <b>
              il est essentiel de maîtriser la prospection physique et la pige
            </b>{' '}
            pour pouvoir tirer tous les bénéfices de cet espace !
          </p>
          <p>
            Perfectionne-toi dès à présent en pige grâce à l&apos;outil{' '}
            <a
              href="https://app.yanport.com/login"
              target="_blank"
              rel="noreferrer"
            >
              Yanport
            </a>
            .
          </p>
          <p>
            Tu peux également découvrir l&apos;espace{' '}
            <a href="/etudier-votre-marche">Etudier mon marché</a>
          </p>
          <p>À très bientôt !</p>
        </div>
        <img src={imgHomeCiblerBienAVendre} alt="Localiser bien à vendre" />
      </div>
      <div className={s.btnWrp}>
        <Button size="lg" variant="primary" href="/">
          Retour Accueil
        </Button>

        <Button
          size="lg"
          as="a"
          variant="primary"
          href="https://app.yanport.com/login"
          target="_blank"
          rel="noreferrer"
        >
          Faire ma pige sur Yanport
        </Button>

        <Button size="lg" variant="primary" href="/etudier-votre-marche">
          Etudier mon marché
        </Button>
      </div>
    </div>
  </Layout>
)

export default BiensAVendreNonAutorise
